import { ChipsideComponent } from "../chipside-component";

export class InfoGroup extends ChipsideComponent {
	constructor() {
		super();

		this.heading = this.getAttribute("heading") ?? "";
		this.editID = this.getAttribute("edit-id") ?? "";
		this.editable = this.hasAttribute("editable");

		this.classList.add("information-group");
	}

	parsedCallback() {
		const extras = this.querySelectorAll(":scope > *:not(chip-inforow)");

		if (this.heading || this.editID || extras.length || this.editable) {
			const headerDiv = document.createElementWithContents("div", this.heading, { className: "information-header" });

			if (this.editID || this.editable) {
				const editButton = document.createElementWithContents("button", '<i class="fas fa-pencil"></i>', {
					type: "button",
					className: "btn-body btn--icon btn--sm information__edit",
					onclick: () => this.raiseEvent("editclicked")
				});

				if (this.editID) { editButton.id = this.editID; }

				editButton.setAttribute("tooltip", "Edit details");
				headerDiv.appendChild(editButton);
			}

			if (extras.length) {
				headerDiv.appendChild(document.createElementWithContents("div", extras, { className: "information__actions" }));
			}

			this.prepend(headerDiv);
		}
	}
}